import { jsx as e, jsxs as r } from "react/jsx-runtime";
import { r as t } from "../../index-CExbjDCE.js";
import { periodDatePickerTheme as a } from "./theme.js";
import { PopoverTrigger as o } from "../Popover/index.js";
const c = (s) => /* @__PURE__ */ e(o, { asChild: !0, children: /* @__PURE__ */ e("button", { className: "w-full text-left outline-hidden", children: /* @__PURE__ */ r("div", { className: a.root.base, children: [
  /* @__PURE__ */ e(t, { className: a.root.icon }),
  /* @__PURE__ */ e("div", { className: "flex-1", children: /* @__PURE__ */ r("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ e("span", { className: a.root.dates, children: s.startDate }),
    /* @__PURE__ */ e("span", { className: "text-xs", children: "to" }),
    /* @__PURE__ */ e("span", { className: a.root.dates, children: s.endDate })
  ] }) }),
  s.showDaysCount && /* @__PURE__ */ r("span", { className: a.root.daysCount, children: [
    s.periodDays,
    " days"
  ] })
] }) }) });
export {
  c as Trigger
};
